import { deepOrange, teal } from '@material-ui/core/colors';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import React, { FC, ReactElement } from 'react';
import { NotFoundBoundary } from 'react-navi';

let theme = createMuiTheme({
  palette: {
    primary: teal,
    secondary: deepOrange
  }
});
theme = responsiveFontSizes(theme);

interface AppProps {
  children: ReactElement;
}

const App: FC<AppProps> = (props: AppProps) => {
  return (
    <ThemeProvider theme={theme}>
      <NotFoundBoundary
        render={() => (
          <div>
            <h1>404 - Not Found</h1>
          </div>
        )}
      >
        {props.children}
      </NotFoundBoundary>
    </ThemeProvider>
  );
};

export default App;
